<template>
    <article class="tile is-child card">
        <header :class="panelClasses">
            <p class="title">{{ title }}</p>
        </header>
        <div class="content">
            <div class="notification">
                <p>{{ message }}</p>
            </div>
        </div>
    </article>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true,
        },

        color: {
            type: String,
            required: true,
        },

        message: {
            type: String,
            required: true,
        },
    },

    data () {
        return {
        };
    },

    computed: {
        panelClasses () {
            let classes = {
                'card-header': true,
                dark: true,
            };

            classes[this.color] = true;

            return classes;
        },
    },
};
</script>
